export default __webpack_public_path__ + "static/media/060_corner2.last.49ed5b2c.png";